import React, {useState, useEffect, useRef} from 'react';
import {withTranslation} from 'react-i18next';
import {useNavigate, useParams} from "react-router-dom";
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import {Tooltip} from "primereact/tooltip";
import {ConfirmDialog} from "primereact/confirmdialog";
import {addLocale, locale} from "primereact/api";
import {InputText} from "primereact/inputtext";
import axios from "axios";
import Cookies from "js-cookie";

import HelpComponent from "../HelpComponent";

const _FM_AccommodationchecklistListComponent = (props) => {

  const {t} = props;
  const navigate = useNavigate();
  const {id,action} = useParams();
  const [accommodationchecklist, setAccommodationchecklist] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rows, setRows] = useState(10);
  const dt = useRef(null);
  const [lazyParams, setLazyParams] = useState({
    first: Number(localStorage.getItem('accommodationchecklist_first')) || 0,
    rows: Number(localStorage.getItem('accommodationchecklist_rows')) || rows,
    page: Number(localStorage.getItem('accommodationchecklist_page')) || 0,
    sortField: localStorage.getItem('accommodationchecklist_sortField') || 'id',
    sortOrder: Number(localStorage.getItem('accommodationchecklist_sortOrder')) || -1,
    filters: JSON.parse(localStorage.getItem('accommodationchecklist_filters')) || null,
  });
  let loadLazyTimeout = null;
  const loadLazyData = () => {
    setLoading(true);
    if (loadLazyTimeout) {
      clearTimeout(loadLazyTimeout);
    }
    loadLazyTimeout = setTimeout(() => {
      let query = window.App.transformQueryParams(lazyParams)
      window.App.setState({rerenderAccommodationchecklistList: false})
      axios({
        method: 'get',
        url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "accommodation-readiness-checklist" + query,
        params: {},
        headers: {
          'Authorization': 'Bearer ' + Cookies.get("userToken"),
          "Sys-name": Cookies.get("instanceId"),
          "Preferred-locale": Cookies.get("language")
        }
      })
        .then(response => {
          setTotalRecords(response.data.data.total_item_count);
          setAccommodationchecklist(response.data.data.items);
          setLoading(false);
        })
        .catch(error => {
          setLoading(false);
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
    }, Math.random() * 1000 + 250);
  }
  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onFilter = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParams(_lazyParams);
  }
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: 10, value: 10},
        {label: 20, value: 20},
        {label: 50, value: 50},
        {label: 200, value: 200}
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', accommodationchecklistSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRows(e.target.value)}
                    />
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', accommodationchecklistSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };

  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button icon="pi pi-eye" className="p-button-sm p-button-secondary p-mr-2"
                tooltip={t('show')}
                tooltipOptions={{position: 'left'}}
                onClick={() => {
                  navigate('/accommodation-readiness-checklist/read/' + rowData.id)
                }}/>
        <Button icon="pi pi-pencil" className="p-button-sm  p-button-warning p-mr-2"
                tooltip={t('edit')}
                tooltipOptions={{position: 'left'}}
                onClick={() => {
                  navigate('/accommodation-readiness-checklist/update/' + rowData.id)
                }}/>
        {/*{rowData && rowData.deleted_at_snapshot ? (*/}
        {/*  <Button icon="pi pi-undo" className="p-button-sm p-button-success"*/}
        {/*          tooltip={t('restore')}*/}
        {/*          tooltipOptions={{position: 'left'}}*/}
        {/*          onClick={() => {*/}
        {/*            axios({*/}
        {/*              method: 'get',*/}
        {/*              url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST*/}
        {/*                + "accommodation-readiness-checklist/" + rowData.id + "/restore",*/}
        {/*              params: {},*/}
        {/*              headers: {*/}
        {/*                'Authorization': 'Bearer ' + Cookies.get("userToken"),*/}
        {/*                "Sys-name": Cookies.get("instanceId"),*/}
        {/*                "Preferred-locale": Cookies.get("language")*/}
        {/*              }*/}
        {/*            })*/}
        {/*              .then(response => {*/}
        {/*                window.App.toastShow('success', t('success_restore'),);*/}
        {/*                loadLazyData();*/}
        {/*              })*/}
        {/*              .catch(error => {*/}
        {/*                window.App.toastShow('error', t('error'), error.toString(), '', error.response);*/}
        {/*              })*/}
        {/*          }}*/}
        {/*  />*/}
        {/*) : (*/}
        {/*  <>*/}
        {/*    <Button icon="pi pi-trash" className="p-button-sm  p-button-danger"*/}
        {/*            tooltip={t('delete')}*/}
        {/*            disabled*/}
        {/*            tooltipOptions={{position: 'left'}}*/}
        {/*            onClick={() => {*/}
        {/*              window.App.setState({[`confirmDelete${rowData.id}`]: true})*/}
        {/*            }}*/}
        {/*    />*/}
        {/*    <ConfirmDialog group="declarative" visible={window.App.state[`confirmDelete${rowData.id}`]}*/}
        {/*                   acceptLabel={t('yes')} rejectLabel={t('no')}*/}
        {/*                   onHide={() => {*/}
        {/*                     window.App.setState({[`confirmDelete${rowData.id}`]: false})*/}
        {/*                   }}*/}
        {/*                   message={t('confirm_delete')} header={t('confirm_delete')} icon="pi pi-exclamation-triangle"*/}
        {/*                   accept={() => {*/}
        {/*                     window.App.delete('accommodation-readiness-checklist', rowData.id)*/}
        {/*                       .then(response => {*/}
        {/*                         window.App.toastShow('success', t('success_delete'),);*/}
        {/*                         loadLazyData();*/}
        {/*                       })*/}
        {/*                       .catch(error => {*/}
        {/*                         window.App.toastShow('error', t('error'), error.toString(), '', error.response);*/}
        {/*                       })*/}
        {/*                   }}*/}
        {/*                   reject={() => {*/}
        {/*                     window.App.setState({[`confirmDelete${rowData.id}`]: false})*/}
        {/*                   }}/>*/}
        {/*  </>*/}
        {/*)}*/}
      </React.Fragment>
    );
  }

  addLocale('default', {
    clear: t('filter_clear'),
    apply: t('filter_apply'),
  });
  locale('default');

  useEffect(() => {
    if (lazyParams.filters) {
      document.getElementById('search').value = '';
      localStorage.setItem('accommodationchecklist_filters', JSON.stringify(lazyParams.filters))
      if (lazyParams.sortField) {
        localStorage.setItem('accommodationchecklist_sortField', lazyParams.sortField)
      }
      if (lazyParams.sortOrder) {
        localStorage.setItem('accommodationchecklist_sortOrder', lazyParams.sortOrder)
      }
      if (lazyParams.first >= 0) {
        localStorage.setItem('accommodationchecklist_first', lazyParams.first)
      }
      if (lazyParams.page >= 0) {
        localStorage.setItem('accommodationchecklist_page', lazyParams.page)
      }
      if (lazyParams.rows) {
        localStorage.setItem('accommodationchecklist_rows', lazyParams.rows)
        setRows(lazyParams.rows)
      }
    }
    loadLazyData();
  }, [lazyParams, window.App.state.rerenderAccommodationchecklistList === true])

  return (
    <>
      <div className={"p-grid"}>
        <div className={"p-col-12 p-lg-4 p-col-align-center"}>
          <h2 className={"p-m-0"}>{t('accommodationchecklist_list')}</h2>
        </div>
        <div className={"p-col p-text-right p-col-align-center"}>
          <HelpComponent type={"site"} position={"UNDER_HELP_BUTTON"}/>
          {localStorage.getItem('accommodationchecklist_filters') &&
            <a style={{color: "red"}} className={"p-button p-button-danger p-ml-2"}
               onClick={() => {
                 localStorage.removeItem('accommodationchecklist_filters')
                 localStorage.removeItem('accommodationchecklist_sortField')
                 localStorage.removeItem('accommodationchecklist_sortOrder')
                 localStorage.removeItem('accommodationchecklist_rows')
                 localStorage.removeItem('accommodationchecklist_page')
                 localStorage.removeItem('accommodationchecklist_first')
                 setLazyParams({
                   ...lazyParams,
                   filters: null
                 })
               }}
            >
              <i className={"pi pi-exclamation-triangle"}></i>&nbsp;{t('clear_filter')}
            </a>
          }
          {/*{lazyParams && lazyParams.is_active === 0 ? (*/}
          {/*  <Button type="button" icon={"pi pi-eye-slash"}*/}
          {/*          label={t('hide_deleted')}*/}
          {/*          onClick={() => {*/}
          {/*            let _lazyParams = lazyParams*/}
          {/*            delete lazyParams.is_active*/}
          {/*            setLazyParams(_lazyParams)*/}
          {/*            loadLazyData()*/}
          {/*          }}*/}
          {/*          className="p-button-danger p-ml-2"/>*/}
          {/*) : (*/}
          {/*  <Button type="button" icon={"pi pi-eye"}*/}
          {/*          label={t('show_deleted')}*/}
          {/*          onClick={() => {*/}
          {/*            setLazyParams({*/}
          {/*              ...lazyParams,*/}
          {/*              is_active: 0*/}
          {/*            })*/}
          {/*          }}*/}
          {/*          className="p-button-success p-ml-2"/>*/}
          {/*)}*/}
          <span className="p-input-icon-left p-ml-2">
              <i className="pi pi-search"/>
              <InputText id="search"
                         placeholder={t('search')}
                         onChange={(e) => {
                           clearTimeout(window.searchTimeout)
                           window.searchTimeout = setTimeout(function () {
                             localStorage.removeItem('accommodationchecklist_filters')
                             localStorage.removeItem('accommodationchecklist_sortField')
                             localStorage.removeItem('accommodationchecklist_sortOrder')
                             localStorage.removeItem('accommodationchecklist_rows')
                             localStorage.removeItem('accommodationchecklist_page')
                             localStorage.removeItem('accommodationchecklist_first')
                             setLazyParams({
                               ...lazyParams,
                               genericSearch: e.target.value,
                               filters: null
                             })
                           }, 1000)
                         }}
                         className={""}
              />
            </span>
          <Button type="button" label={t('new_accommodationchecklist')} icon={"pi pi-plus"}
                  onClick={() => {
                    navigate('/accommodation-readiness-checklist/create')
                  }}
                  className="p-button-success p-ml-2"/>
        </div>
      </div>
      {/* <HelpComponent type={"list_box"} box={"accommodation-readiness-checklist"}/> */}
      <DataTable
        ref={dt}
        size={"small"}
        emptyMessage={t('empty_message')}
        value={accommodationchecklist} paginator first={lazyParams.first} totalRecords={totalRecords} onPage={onPage}
        onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
        onFilter={onFilter} filters={lazyParams.filters} loading={loading} lazy
        paginatorTemplate={pager} rows={rows}
        autoLayout={true}
        filterDisplay="menu"
        responsiveLayout={window.App.state.responsiveLayout}
        breakpoint="1365px"
        stripedRows
        dataKey="id"
        selectionMode={"single"}
        onRowDoubleClick={(rowData) => {
          if(!rowData.data.deleted_at_snapshot)
            navigate('/accommodation-readiness-checklist/update/' + rowData.data.id)
        }}
      >
        
        <Column field="name" sortable header={t('name')}></Column>
        <Column field="items" sortable header={t('items')} body={(rowData) => {
          const items = Array.isArray(rowData.items)
            ? rowData.items.join(", ")
            : "";
          return (
            <>
              <span className={"tt_items"}>
                {items.length > 50 ? `${items.substring(0, 50)}...` : items}
              </span>
              <Tooltip target=".tt_items"/>
            </>
          )
        }}></Column>
        <Column body={actionBodyTemplate} className={"p-py-0 p-text-nowrap p-text-right"}></Column>
      </DataTable>
    </>
  )
}
export default withTranslation('common')(_FM_AccommodationchecklistListComponent);
